import { render, staticRenderFns } from "./TheProfile.vue?vue&type=template&id=0cafbc3c&scoped=true&"
import script from "./TheProfile.vue?vue&type=script&lang=js&"
export * from "./TheProfile.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0cafbc3c",
  null
  
)

export default component.exports